import { Mail, Phone, MapPin, Facebook, Instagram } from 'lucide-react';
import tradeLogo from "../../assets/trade-logo.jpeg";
import tiktok from "../../assets/tiktok.png";
import { Link } from 'react-router';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <img src={tradeLogo} alt="logo" className="h-12" />

              <span className="text-xl font-bold">Trade Enrich</span>
            </div>
            <p className="text-gray-400 text-sm">
              Save Smarter. Earn Monthly. Build Wealth.
            </p>
            <p className="text-gray-400 text-sm">
              Your trusted partner in building financial freedom through smart savings and consistent returns.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                  Savings Plans
                </Link>
              </li>
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                  FAQs
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
                  Contacts
                </Link>
              </li>

            </ul>
          </div>

          {/* Legal */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-white transition-colors">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/security" className="text-gray-400 hover:text-white transition-colors">
                  Security
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-gray-400 hover:text-white transition-colors">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Contact Info</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-center space-x-3">
                <Mail className="h-4 w-4 text-blue-400" />
                <span className="text-gray-400">support@tradeenrich.com</span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="h-4 w-4 text-blue-400" />
                <span className="text-gray-400">+234 7063441554</span>
              </div>
              <div className="flex items-center space-x-3">
                <MapPin className="h-4 w-4 text-blue-400" />
                <span className="text-gray-400">Late Thomas and Paulina Ibe's New Compound Umuodo Imo State, Nigeria</span>
              </div>
            </div>

            {/* Social Media */}
            <div className="space-y-2">
              <h4 className="text-sm font-medium">Follow Us</h4>
              <div className="flex space-x-3">
                {/* Facebook */}
                <a
                  href="https://facebook.com/Trade-Enrich"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  <Facebook className="h-5 w-5" />
                </a>

                {/* Instagram */}
                <a
                  href="https://instagram.com/Trade_Enrich20"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  <Instagram className="h-5 w-5" />
                </a>

                {/* TikTok */}
                <a
                  href="https://www.tiktok.com/@trade.enrich"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  {/* <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 256 256"
                    fill="currentColor"
                    className="h-5 w-5"
                  >
                    <path d="M220 92.6a59.9 59.9 0 0 1-34-10.5v56.4a60 60 0 1 1-60-60 60.9 60.9 0 0 1 10 .8V55.3a84.2 84.2 0 0 0-10-.6A84 84 0 1 0 210 139V98.5a84.7 84.7 0 0 0 10 0v-5.9Z" />
                  </svg> */}
                  <img src={tiktok} alt="tiktok" className="h-5" />
                </a>

                {/* WhatsApp */}
                <a
                  href="https://wa.me/2349162221366"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 256 256"
                    className="h-5 w-5"
                  >
                    <path d="M128 24A104 104 0 0 0 46.5 184.2L32.2 223a8 8 0 0 0 10.3 10.3l38.8-14.3A104 104 0 1 0 128 24Zm0 192a88 88 0 0 1-45.5-12.4 8 8 0 0 0-7.1-.4L50 211.5l7.4-20.1a8 8 0 0 0-.7-7.3A88 88 0 1 1 128 216Zm45.7-63.5a32.2 32.2 0 0 1-12.7 7.6c-3.3 1.1-7.5.8-12.3-1.2a70.3 70.3 0 0 1-22.8-14.8 78.2 78.2 0 0 1-15.3-20.2c-3.3-5.8-4.1-10.7-2.5-14.9a25.6 25.6 0 0 1 3.7-6.3l4.2-5.3a7.8 7.8 0 0 1 6-2.9h.3a6.3 6.3 0 0 1 5.3 2.9l7.4 11.5a8.3 8.3 0 0 1-.4 9.4l-2.7 3.8a2.2 2.2 0 0 0-.1 2.2 51.6 51.6 0 0 0 8.7 11.4 43.9 43.9 0 0 0 11.3 7.7 2.4 2.4 0 0 0 2.3 0l4.5-2.3a8 8 0 0 1 8.3.6l9.8 6.7a7.9 7.9 0 0 1 3.5 5.8 8.1 8.1 0 0 1-1.2 5.5Z" />
                  </svg>
                </a>
              </div>
            </div>

          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} Trade Enrich. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
